import Route from "../../routes/Route_home";
import { HelmetProvider, Helmet } from "react-helmet-async";

function Devalls() {
  return (
    <HelmetProvider>
      <Helmet>
        <link rel="canonical" href="https://www.devalls.com/devalls" />
      </Helmet>
      <Route />
    </HelmetProvider>
  );
}

export default Devalls;
